import { BaseModel } from "./base.model";

export class EmpresaModel extends BaseModel {
    public Id: number;
    public Nombre: string;
    public Imagen: string;
    public IdGestion: number;
    public Cartografia: string;
}